import { getEcgStatus } from './ecgStatus';

const EcgEnabledText = (record) => {
    const { color, label } = getEcgStatus(record);
    return <span style={{ color }}>{label}</span>;
};

export default EcgEnabledText;
